import { Decorator } from './Decorator';
import { TaskStatus } from '../TaskStatus';
import { isIConditional } from '../conditionals/IConditional';
/**
 * 装饰器，只有在满足条件的情况下才会运行其子程序。
 * 默认情况下，该条件将在每一次执行中被重新评估
 */
export class ConditionalDecorator extends Decorator {
    constructor(conditional, shouldReevalute = true) {
        super();
        this.discriminator = "IConditional";
        this._conditionalStatus = TaskStatus.Invalid;
        if (!isIConditional(conditional)) {
            throw new Error("conditional 必须继承 IConditional");
        }
        this._conditional = conditional;
        this._shouldReevaluate = shouldReevalute;
    }
    invalidate() {
        super.invalidate();
        this._conditionalStatus = TaskStatus.Invalid;
    }
    onStart() {
        this._conditionalStatus = TaskStatus.Invalid;
    }
    update(context) {
        if (!this.child) {
            throw new Error("child不能为空");
        }
        this._conditionalStatus = this.executeConditional(context);
        if (this._conditionalStatus == TaskStatus.Success)
            return this.child.tick(context);
        return TaskStatus.Failure;
    }
    /**
     * 在shouldReevaluate标志之后执行条件，或者用一个选项来强制更新。
     * 终止将强制更新，以确保他们在条件变化时得到适当的数据。
     */
    executeConditional(context, forceUpdate = false) {
        if (forceUpdate || this._shouldReevaluate || this._conditionalStatus == TaskStatus.Invalid)
            this._conditionalStatus = this._conditional.update(context);
        return this._conditionalStatus;
    }
}
//# sourceMappingURL=ConditionalDecorator.js.map